<template>
  <div class="home">
    <!--    banner-->
    <el-carousel indicator-position="none" height="400px" arrow="never">
      <el-carousel-item v-for="(item,index) in banner" :key="index">
        <div class="objImg img" :style="'backgroundImage: url('+item.img+')'">
          <h2 class="bannerText" v-html="item.text"></h2>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!--    类型-->
    <div class="type flex">
      <div class="typeList" v-for="(item,index) in type" :key="index">
        <div class="flex">
          <img :src="item.img" alt="" class="img">
          <img :src="item.activeImg" alt="" class="activeImg">
          <h3>{{ item.title }}</h3>
        </div>
        <p class="desc">{{ item.desc }}</p>
      </div>
    </div>

    <!--    专家团队-->
    <div class="flex doctor  news">
      <div>
        <el-carousel class="user" indicator-position="none" height="400px" arrow="never" :interval="5000">
          <el-carousel-item v-for="obj in doctorList" :key="obj.id">
            <div class="headImgPath img" :style="'backgroundImage: url('+obj.headImgPath+')'">
              <div class="desc">
                <strong>{{ obj.fullName }} {{ obj.enName }}</strong>
                <p>擅长：{{ obj.skill }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <p class="certification">国际/华人权威认证的心理医生</p>
      </div>
      <div class="right">
        <h1>心理亦笙专家团队</h1>
        <p class="text">以美国的精神科医生、神经科医生和内科医生团队为基础，同时吸纳中国的神经、精神和心理方面的专家学者参与，为中美欧华人及留学生提供专业的心理辅导与帮助！
          同时，也为中美业界同胞提供最新的学术研究新闻，为中国同行提供更便利高效的精神学药库等方面的服务。</p>
        <strong>心理亦笙致力于为您解决：</strong>
        <div class="result">
          <div class="list" v-for="(item,index) in result" :key="index">
            <p class="title">{{ item.title }}</p>
            <div class="content">
              <span v-for="(obj,ind) in item.content" :key="ind"><i class="el-icon-check"></i>{{ obj }}</span>
            </div>
          </div>
        </div>
        <el-button class="readMore" @click="toDoctorPage">查看更多专家</el-button>
      </div>
    </div>
    <div class="doctorList news">
      <h3>经过平台统一培训并认证的，国内的心理专家和精神科医生</h3>
      <div class="userSwiperOptions">
        <swiper ref="drugSwiper" :options="userSwiperOptions">
          <swiper-slide v-for="item  in teamDoctorList" :key="item.id">
            <div class="consultantList" @click="toHomePage(item.account)">
              <div class="img" :class="{'default-headImg':item.headImgPath}"
                   :style="{backgroundImage: (item.headImgPath? 'url('+item.headImgPath+')':'')}"
                   :gender="!item.headImgPath?item.gender:''">
                <div class="mark">
                  <div class="flexText">
                    <div class="flex">
                      <h4 class="enName">{{ item.fullName }}</h4>
                      <span class="workAge">· 从业{{ item.startWorkDate | workAge }}年</span>
                    </div>
                    <h5 class="enName">{{ item.enName ? item.enName : '' }}</h5>
                    <p class="enName">{{ item.company }}{{ item.technicalTitle }}</p>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>

    <!--    怎样帮助你-->
    <div class="help news">
      <h2>怎样帮助你</h2>
      <div class="helpList flex">
        <template v-for="(item,ind) in helpList">
          <div class="listContent" :key="'a'+ind">
            <img :src="item.img" alt="" width="160">
            <h4>{{ item.tit }}</h4>
            <p>{{ item.text }}</p>
          </div>
          <div class="" :key="'b'+ind" :style="{'display':(ind==2?'none':'')}"><img
              src="../../assets/images/help_04.png" alt=""></div>
        </template>
      </div>
      <el-button class="start_visits" @click="toConsulting()">马上咨询</el-button>
    </div>

    <!--    为什么选择我们-->
    <div class="why">
      <div class="news">
        <h2>为什么选择我们</h2>
        <div class="whyContent flex">
          <div class="left">
            <img src="/static/imgs/website_text_logo.png" alt="" width="140">
            <p><span>全球各地有执照的心理医生或治疗师</span></p>
            <p>可<span> 跨区域 </span>选择心理医生或咨询师</p>
            <p><span>随时随地 </span>可咨询或发送消息</p>
            <p><span>视频为主 </span>文字图片为辅助</p>
            <p>轻松安排咨询预约</p>
            <p>帮助寻找优质咨询室</p>
            <p>提供药物使用建议</p>
          </div>
          <div class="right">
            <h2>线下咨询</h2>
            <p>提供有执照的医生或治疗师</p>
            <p>地域限制</p>
            <p>沟通限制</p>
            <p>仅面对面单一咨询方式</p>
            <p>需要根据咨询室的情况选择咨询时间</p>
            <p>单一选择咨询室</p>
            <p>提供药物使用建议</p>
          </div>
        </div>
      </div>
    </div>

    <!--    越来越多的人选择心理亦笙-->
    <div class="feedback">
      <h2>越来越多的人选择心理亦笙</h2>
      <swiper ref="drugSwiper" class="deedbackList" :options="feedbackSwiperOptions">
        <swiper-slide v-for="item in feedback" :key="item.id">
          <div class="leftBack">
            <div class="img userImg" :style="'backgroundImage: url('+feedbackHead(item)+')'"></div>
            <div class="desc">
              <img src="../../assets/img/marks.png" class="leftTopImg" alt="" width="32">
              <p>{{ item.content }}</p>
              <img src="../../assets/img/marks.png" class="rightBottomImg" alt="" width="32">
              <div style="clear:both;"></div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <!--    常见问题-->
    <div class="why">
      <div class="news">
        <h2>常见问题</h2>
        <el-collapse class="dobut" v-model="active" accordion>
          <el-collapse-item
              class="problemOptions" v-for="(item,index) in problemOptions"
              :key="index" :name="index">
            <template slot="title"><h3 class="flex"><i class="icon">Q</i>{{ item.itemName }}</h3></template>
            <p class="answer">
              <span class=" icon">A</span>
              <span class="itemDesc">{{ item.itemDesc }}</span>
            </p>
          </el-collapse-item>
          <router-link to="/doubt" class="readMore">查看更多疑惑>></router-link>
        </el-collapse>
      </div>
    </div>

    <!--    购买会员卡-->
    <div class="members">
      <div class="news flex">
        <div class="left">
          <h1>给自己和爱的人一份礼物</h1>
          <p>心理治疗是送给亲人、朋友、爱的人最好的礼物<br/>
            定制会员可用于线上咨询<br/>
            并定制线下礼包送给自己或爱的人
          </p>
          <el-button class="pay">购买会员卡</el-button>
        </div>
        <div class="right">
          <img src="../../assets/images/people.png" alt="" height="400">
        </div>
      </div>
    </div>

    <!--    尾部-->
    <div class="introduce">
      <div class="news">
        <div class="ysh">
          <img src="../../assets/img/logoFotter.png" alt="">
          <p>吸纳中外的心理、精神和神经方面的专家学者参与，为中美欧华人及留学生提供专业的心理辅导与专业帮助！</p>
          <p>同时，这个平台也给中美业界同行们提供最新的学术研究新闻，为中国同行提供便利高效的精神学药库等其他方面的服务。</p>
          <p>欢迎您加盟我们团队，为用户服务！</p>
        </div>
        <div class="concact">
          <p class="tit">联系我们</p>
          <div class="concactInfo">
            <p>{{ contact.email }}</p>
            <p>{{ contact.tel }}</p>
          </div>
          <div class="showFeedbackDialog">
            <p class="tit">咨询反馈</p>
            <div class="inputFeed flex" @click="showFeedbackDialog()">
              <span>请留下您的咨询感受</span>
              <span>提交</span>
            </div>
          </div>

        </div>
        <div class="shortcutMenu">
          <p class="tit">快捷菜单</p>
          <div class="listMenu">
            <a v-for="(item,index) in shortcutMenu" :href="item.path" :key="index">{{ item.tit }}</a>
          </div>
        </div>
<!--        <div class="peopleNum flex">
          <div>
            <h1>{{ statistics.doctors }}</h1>
            <span>注册医生</span>
          </div>
          <div>
            <h1>{{ statistics.users }}</h1>
            <span>注册用户</span>
          </div>
        </div>
        <div class="peopleNum flex">
          <div>
            <h1>{{ statistics.appoints }}</h1>
            <span>咨询次数</span>
          </div>
          <div>
            <h1>{{ statistics.visits }}</h1>
            <span>访问次数</span>
          </div>
        </div>-->
      </div>
    </div>

    <!-- 登录弹窗 -->
    <loginDialog ref="loginDialog"></loginDialog>

    <!--    用户反馈对话框 start-->
    <el-dialog top="0" :visible.sync="showAddFeedbackDialog" :close-on-click-modal="false"
               :show-close="false" width="500px" class="updateMem" :close-on-press-escape="false">
      <template #title>
        <h1 class="tit">用户反馈</h1>
      </template>
      <el-form :model="addFeedbackData" class="rowsInfo" label-suffix="：" label-width="90px" :rules="addFeedbackRules"
               ref="addFeedbackForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addFeedbackData.title" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="addFeedbackData.contact" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="4" v-model="addFeedbackData.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeFeedbackDialog()">取 消</el-button>
        <el-button type="primary" @click="addFeedback()">确 定</el-button>
      </div>
    </el-dialog>
    <!--    用户反馈对话框 end-->

    <!--    悬浮框-->
    <suspensionDrawer></suspensionDrawer>

  </div>

</template>

<script>
import loginDialog from "@/components/loginDialog";
import base from "@/api/common";
import suspensionDrawer from "@/components/suspensionDrawer";

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

require("swiper/dist/css/swiper.css");

export default {
  name: "home",
  data() {
    return {
      banner: [
        {img: require('../../assets/images/banner.png'), text: '用科学依据来维护<br/>大脑健康'},
        {img: require('../../assets/images/banner.png'), text: '用科学认知<br/>大脑'}
      ],
      type: [
        {
          img: require('../../assets/images/type_01.png'),
          activeImg: require('../../assets/images/typeAct_01.png'),
          title: '个人咨询',
          desc: '专为个人舒缓生活、工作及学习造成的各种压力'
        },
        {
          img: require('../../assets/images/type_02.png'),
          activeImg: require('../../assets/images/typeAct_02.png'),
          title: '伴侣咨询',
          desc: '专为伴侣缓解生活相处中所产生的种种问题'
        },
        {
          img: require('../../assets/images/type_03.png'),
          activeImg: require('../../assets/images/typeAct_03.png'),
          title: '青少年咨询',
          desc: '专为13-18岁青少年提供专业的心理咨询'
        },
        {
          img: require('../../assets/images/type_04.png'),
          activeImg: require('../../assets/images/typeAct_04.png'),
          title: '企业咨询',
          desc: '专为您的员工纾解压力，提高工作效率'
        }
      ],
      // 尾部信息
      contact: {
        email: 'service@yshinfo.com',
        tel: '0755-28291983'
      },
      // 统计
      statistics: {
        doctors: 126,
        appoints: 1653,
        users: 3692,
        visits: 7655
      },
      // 导航
      shortcutMenu: [
        {tit: '我要咨询', path: '/consult'},
        {tit: '专业医生', path: '/famousDoctor'},
        {tit: '每日研究', path: '/study'},
        {tit: '专业用药', path: '/medication'},
        {tit: '新闻资讯', path: '/news'},
        {tit: '专家会议', path: '/consultation'}
      ],
      // 用户反馈
      showAddFeedbackDialog: false, //展示用户反馈对话框
      addFeedbackData: {//添加用户反馈的数据
        title: null,//标题
        content: null,//内容
        contact: null,//联系方式
      },
      addFeedbackRules: {//用户反馈校验
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入反馈内容', trigger: 'blur'},
        ],
        contact: [
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
      },
      //专家团队
      doctorList: [],
      //解决
      result: [
        {title: "生活压力", content: ["青少年心理", "学习压力", "失去亲人", "教育问题", "工作压力", "老人痛苦", "夫妻不睦"]},
        {
          title: "精神疾病",
          content: ["抑郁症", "性功能障碍", "多动症", "抑郁狂躁症", "精神分裂", "自闭症", "焦虑症", "饮食失调症", "老年痴呆症", "失眠症", "药物滥用症", "其他"]
        },
        {title: "常见疾病带来的困扰", content: ["用药的副作用", "内科疾病", "心理疾病与其他疾病的关系", "疾病带来的影响"]},
      ],
      userSwiperOptions: {
        slidesPerView: 5,
        speed: 1500,
        loop: true,
        autoplay: 2000,
        autoplayDisableOnInteraction: true,
        loopedSlides: 5,
        loopAdditionalSlides: 3,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
      },
      teamDoctorList: [],
      // 帮助
      helpList: [
        {img: require('../../assets/images/help_01.png'), tit: '初次评估', text: '用户的首次服务需要填写量表，由助理咨询师提供基础评估服务'},
        {
          img: require('../../assets/images/help_02.png'),
          tit: '匹配治疗师',
          text: '通过初次评估和沟通，为您匹配最适合的心理专家或精神科医生'
        },
        {img: require('../../assets/images/help_03.png'), tit: '开始视频', text: '预约咨询时间，与心理专家或精神科医生视频沟通以解决您的困扰'},
      ],
      // 用户反馈
      feedback: [],
      feedbackSwiperOptions: {
        observer: true,
        initialSlide: 1,
        observeSlideChildren: true,
        observeParents: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 1000,
        autoplay: false,
      },
      // 用户疑惑
      problemOptions: [],
      active: 0,
    }
  },
  mounted() {
    // 统计
    this.$ajax.get(base.basePath + 'auth/auth-doctor/statistics').then(res => {
      if (res.data.status === 'success') {
        this.statistics.doctors = res.data.doctors;
        this.statistics.appoints = res.data.appoints;
      }
    });
    this.$ajax.get(base.basePath + 'auth/auth-user/statistics').then(res => {
      if (res.data.status === 'success') {
        this.statistics.users = res.data.users;
      }
    });
    this.$ajax.get(base.basePath + 'communication/comm-visit-history/visits/count').then(res => {
      if (res.data.status === 'success') {
        this.statistics.visits = res.data.data;
      }
    })
    // 专家团队
    this.$ajax.get(base.api.recommend.doctor).then((res) => {
      if (res.data.status === 'success') {
        this.doctorList = res.data.list;
      }
    })
    // 注册医生+咨询师
    let condition = {
      current: 1,
      size: 15,
      orderByNewest: 1
    };
    this.$ajax.post(base.api.doctor.condition, condition).then(res => {
      if (res.data.status === 'success') {
        this.teamDoctorList = res.data.rows;
      }
    });
    //获得用户反馈
    this.$ajax.get(base.api.feedback.list).then((res) => {
      if (res.data.status === 'success') {
        this.feedback = res.data.list
      }
    })
    //获取用户疑惑
    this.$ajax.get(base.api.dict.userQA).then((res) => {
      if (res.data.status === 'success') {
        this.problemOptions = res.data.list.slice(0, 5);
      }
    })
    $(".contentIndex").animate({scrollTop: '0px'}, 800);
  },
  filters: {
    workAge: function (date) {
      date = date.substr(0, 4);
      let d = new Date();
      d = d.getFullYear();
      let age = d - date;
      return age;
    }
  },
  methods: {
    //添加用户反馈
    addFeedback() {
      this.$refs['addFeedbackForm'].validate((valid) => {
        if (valid) {
          let that = this;
          this.$ajax.post(base.api.feedback.add, this.addFeedbackData).then((res) => {
            if (res.data.status === 'success') {
              that.$message.success('提交成功');
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error("操作异常");
          }).finally(() => {
            that.closeFeedbackDialog();
          })
        } else {
          this.$message.error("请检查数据");
          return false;
        }
      });
    },
    closeFeedbackDialog() {
      this.addFeedbackData = {
        title: null,
        content: null,
        contact: null,
      };
      this.showAddFeedbackDialog = false;
    },
    async showFeedbackDialog() {
      let that = this;
      let user = await base.utils.getCurrent();
      if (user == null) {
        that.$refs.loginDialog.dialogVisible = true;
        that.$refs.loginDialog.reloadCode('vcode-user');
        that.$refs.loginDialog.successUrl = '/index';
      } else {
        this.showAddFeedbackDialog = true;
      }
    },
    async toConsulting() {
      let that = this;
      let user = await base.utils.getCurrent();
      if (user == null) {
        that.$refs.loginDialog.dialogVisible = true;
        that.$refs.loginDialog.reloadCode('vcode-user');
        that.$refs.loginDialog.successUrl = '/consult';
      } else {
        await this.$router.push({name: 'consult'});
      }
    },
    //医生主页
    toHomePage(account) {
      this.$router.push({path: '/' + account})
    },
    // 用户反馈
    feedbackHead(obj) {
      if (obj.headImgPath) {
        return obj.headImgPath
      } else {
        if (obj.gender === 1) {
          return '/static/imgs/feedback_man.png'
        } else if (obj.gender === 0) {
          return '/static/imgs/feedback_woman.png'
        } else {
          return '/static/imgs/feedback_man.png'
        }
      }
    },
    // 查看更多专家
    toDoctorPage() {
      this.$router.push({name: 'famousDoctor'});
    },
  },
  components: {
    loginDialog,
    suspensionDrawer,
    Swiper,
    SwiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.drugSwiper.$swiper
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/home';
</style>
